import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class AddKundorderradCommand extends BasicCommand<AddKundorderradCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<AddKundorderradCommand>;
    kundorderId: number;
    kundorderradId: number;
    kvantitet: number;
    lagerplatser: number;
    handelssortimentId: number;
    mottagningsplatsId: number;
    periodFrom: string;
    periodTom: string;
    manuellPaArbetsorder: boolean;
    egenskapskodX: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "AddKundorderradCommand";

    constructor(kundorderId: number) {
        super(AddKundorderradCommand.type, "kundorderrad", CommandType.Insert);
        this.kundorderId = kundorderId;
    }
}
